export const TITLE = "Roteirizador grátis: rota, pedágio e combustível | TrajetoFácil";
export const DESCRIPTION =
  "Roteirizador grátis para planejar viagem no Brasil: calcule rota, tempo, pedágio e combustível por carro, moto, ônibus ou caminhão, ida e volta, sem cadastro.";

export const FAQ = [
  {
    q: "Qual a diferença entre rota otimizada e rota mais rápida?",
    a: "A rota mais rápida prioriza o menor tempo de viagem, mesmo que passe por mais pedágios ou rode mais quilômetros. A rota otimizada busca o melhor equilíbrio entre distância, tempo e custo — normalmente resultando em menos gasto de combustível e pedágio.",
  },
  {
    q: "Dá pra roteirizar várias paradas de uma vez?",
    a: "Nesta versão o TrajetoFácil calcula um trecho por vez (origem e destino, com opção de ida e volta). Para vários pontos, calcule cada trecho e some os custos; o suporte a múltiplas paradas está no roteiro de evolução.",
  },
  {
    q: "O roteirizador é grátis?",
    a: "Sim. O TrajetoFácil é gratuito e não exige cadastro para calcular rota, pedágio e combustível.",
  },
  {
    q: "Como o valor do pedágio é calculado?",
    a: "Usamos as tarifas oficiais das praças das rodovias federais (dados abertos da ANTT, calculadas por praça) somadas às praças estaduais mapeadas ao longo do trajeto, aplicando a regra de eixos do veículo escolhido (moto, carro, ônibus ou caminhão). O valor apresentado é uma estimativa atualizada automaticamente com as fontes oficiais.",
  },
  {
    q: "Como calcular o gasto de combustível da viagem?",
    a: "Informe o preço por litro e quantos quilômetros o veículo faz com um litro. O cálculo é distância dividida pelo consumo, multiplicada pelo preço do litro — feito separadamente para ida e volta.",
  },
  {
    q: "Os valores de pedágio e combustível estão atualizados?",
    a: "As tarifas são revisadas automaticamente toda semana com base nas fontes oficiais, e revisões manuais acontecem quando há reajuste anunciado ou divergência reportada. O combustível usa o preço por litro e o consumo que você informa.",
  },
  {
    q: "De onde vêm os dados de pedágio?",
    a: "Das tabelas oficiais da ANTT (rodovias federais), da ARTESP e demais reguladores estaduais, complementadas pelas tabelas publicadas pelas concessionárias. A metodologia completa está na página Metodologia.",
  },
  {
    q: "Posso usar sem informar preço do litro e km/l?",
    a: "Pode. Deixando esses dois campos em branco e preenchendo apenas o valor por km, o cálculo passa a ser distância multiplicada por esse valor, com o pedágio somado à parte.",
  },
  {
    q: "Como calcular uma rota com várias paradas?",
    a: "Adicione até seis pontos na ordem do roteiro. Cada trecho é calculado separadamente, com distância, combustível e praças próprias, e o custo total soma todos eles.",
  },
  {
    q: "Dá para compartilhar a simulação com outra pessoa?",
    a: "Sim. O link gerado carrega origem, destino, paradas, veículo e parâmetros de custo, então quem abrir vê exatamente a mesma simulação — útil para anexar a um orçamento.",
  },
  {
    q: "Por que o valor pago pode ser diferente da estimativa?",
    a: "Desconto de tag, reajuste muito recente, pórticos de cobrança eletrônica, eixo suspenso em caminhão vazio e desvios de rota podem alterar o valor. A página Metodologia lista todas as limitações conhecidas.",
  },
];

export const CONTENT_LINKS = [
  {
    to: "/como-funciona" as const,
    title: "Como funciona",
    text: "O passo a passo da simulação e o significado de cada número do resultado.",
  },
  {
    to: "/metodologia" as const,
    title: "Metodologia",
    text: "As fórmulas, as fontes oficiais, a frequência de atualização e as limitações.",
  },
  {
    to: "/recursos" as const,
    title: "Recursos",
    text: "Combustível, eixos, ida e volta, paradas, custo por km, multiplicador e link.",
  },
  {
    to: "/guias" as const,
    title: "Guias",
    text: "Artigos com exemplos numéricos de pedágio, combustível e precificação.",
  },
  {
    to: "/casos-de-uso" as const,
    title: "Casos de uso",
    text: "Viagem pessoal, deslocamento profissional e controle de custos em empresas.",
  },
  {
    to: "/sobre" as const,
    title: "Sobre",
    text: "O que é o TrajetoFácil, para quem serve e como o projeto é mantido.",
  },
];

export const HOW_TO_STEPS = [
  { name: "Informe a origem", text: "Digite o CEP, a cidade ou o endereço de onde a viagem começa." },
  { name: "Informe o destino", text: "Digite o CEP, a cidade ou o endereço de chegada." },
  { name: "Escolha o veículo", text: "Selecione carro, moto, ônibus ou caminhão e, se necessário, o número de eixos." },
  { name: "Preencha combustível", text: "Informe o preço por litro e os quilômetros por litro do veículo." },
  { name: "Clique em Buscar rota", text: "Veja distância, tempo, combustível e pedágio de cada sentido e o custo total." },
  { name: "Repassa o custo", text: "Use o multiplicador de repasse para definir o valor a cobrar por km ou pela viagem." },
];
